<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="canManagePeople ? items : null" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <!-- <div class="wordset">
                <ul>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"
                      ><img src="../../../assets/img/icons/pdf.svg" alt="img"
                    /></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                      ><img src="../../../assets/img/icons/excel.svg" alt="img"
                    /></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"
                      ><img src="../../../assets/img/icons/printer.svg" alt="img"
                    /></a>
                  </li>
                </ul>
              </div> -->
            </div>
            <!-- /Filter -->
            <!-- <div
              class="card"
              id="filter_inputs"
              :style="{
                display: filter ? 'block' : 'none',
              }"
            >
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Supplier Code" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Supplier" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Phone" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Email" />
                    </div>
                  </div>
                  <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                    <div class="form-group">
                      <a class="btn btn-filters ms-auto"
                        ><img src="../../../assets/img/icons/search-whites.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="filteredItems"
                :row-key="record => record.vendorid"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'vendorid'">
                    <div class="productimgname">
                     
                      <a href="javascript:void(0);">{{ record.vendorname }}</a>
                    </div></template
                  >

                  <template v-else-if="column.key === 'action' && canManagePeople">
                    <a class="me-3" @click="editvendor(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>  
                    <a
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                      @click="showAlert(record.vendorid)"
                    >
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
  <supplierlistmodal></supplierlistmodal>
</template>
<script setup>
import { computed, toRefs } from 'vue';
import { useAuthenticator } from '@aws-amplify/ui-vue';

const { user } = toRefs(useAuthenticator());
const canManagePeople = computed(() => user.value?.attributes?.['custom:role'] === 'Admin');
</script>
<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.common['api-key'] = process.env.VUE_APP_API_KEY;
const columns = [
  {
    sorter: true,
  },
  {
    title: "Supplier Name",
    dataIndex: "vendorname",
    key: "vendorid",
    sorter: {
      compare: (a, b) => {
        a = a.vendorname.toLowerCase();
        b = b.vendorname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
   title: "Contact person",
    dataIndex: "contactperson",
    sorter: {
      compare: (a, b) => {
        a = a.contactperson.toLowerCase();
        b = b.contactperson.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Address",
    dataIndex: "address",
    sorter: {
      compare: (a, b) => {
        a = a.address.toLowerCase();
        b = b.address.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Email",
    dataIndex: "email",
    sorter: {
      compare: (a, b) => {
        a = a.email.toLowerCase();
        b = b.email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    sorter: {
      compare: (a, b) => {
        a = a.phone;
        b = b.phone;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const normalizeVendor = (vendor) => ({
  vendorid: vendor.vendorid || vendor.VendorId || vendor.id || '',
  vendorname: vendor.vendorname || vendor.VendorName || vendor.SupplierName || vendor.name || '',
  contactperson: vendor.contactperson || vendor.ContactPerson || '',
  address: vendor.address || vendor.Address || '',
  email: vendor.email || vendor.Email || '',
  phone: vendor.phone || vendor.Phone || '',
});

const getVendorListFromResponse = (responseData) => {
  if (typeof responseData === 'string') {
    try {
      return getVendorListFromResponse(JSON.parse(responseData));
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  if (Array.isArray(responseData)) return responseData;
  if (responseData?.body) return getVendorListFromResponse(responseData.body);
  if (Array.isArray(responseData?.data)) return responseData.data;
  if (Array.isArray(responseData?.vendors)) return responseData.vendors;
  if (Array.isArray(responseData?.suppliers)) return responseData.suppliers;
  if (responseData && typeof responseData === 'object') {
    return Object.values(responseData).filter(item => item && typeof item === 'object');
  }
  return [];
};

export default {
  data() {
    return {
      filter: false,
      search: '',
      title: "Suppliers List",
      title1: "Manage your Supplier",
      items: [
        {
          text: "Add Supplier",
          addname: "/addsupplier",
        },
      ],
      data: [],
      columns,
    };
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/supplierlist' && event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        event.preventDefault(); 
        
        this.$router.push('/addsupplier');
      }
    },
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      // Use sweetalert2
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .delete('/v1/vendors/'+id)
          .then(response => {
            //this.res = "Status " + response.status + ". Category created";
            Swal.fire("Deleted!", "Supplier has been deleted.");
            var index = this.data.findIndex(function(o){
              return o.vendorid === id;
            })
            if (index !== -1) this.data.splice(index, 1);
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
          
        }
      });
    },
    editvendor(vendor) {
      this.$router.push({ path: '/editsupplier', query: { id: vendor.vendorid } });
    },
    async getvendor() {
      axios
      .get('/v1/vendors')
      .then(response => {
        this.data = getVendorListFromResponse(response.data).map(normalizeVendor)
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  computed: {
    filteredItems() {
      return (this.data || []).filter(item => {
        const vendorName = (item.vendorname || '').toString().toLowerCase();
        const query = (this.search || '').toLowerCase();
        return !this.search || 
                vendorName.includes(query);
      });
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    this.getvendor();
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  name: "supplierlist",
};
</script>
          
